"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlStateHandler = exports.EntityState = exports.EntityPhysics = exports.BaseSimulator = exports.PhysicsSettings = exports.EPhysicsCtx = exports.initSetup = void 0;
const settings_1 = require("./physics/settings");
const wrapper_1 = require("./wrapper");
function loader(bot) {
    if (!bot.physicsUtil) {
        initSetup(bot.registry);
        bot.physicsUtil = new wrapper_1.PhysicsUtilWrapper(bot);
    }
}
exports.default = loader;
function initSetup(data) {
    settings_1.EPhysicsCtx.loadData(data);
    settings_1.PhysicsSettings.loadData(data);
}
exports.initSetup = initSetup;
var settings_2 = require("./physics/settings");
Object.defineProperty(exports, "EPhysicsCtx", { enumerable: true, get: function () { return settings_2.EPhysicsCtx; } });
Object.defineProperty(exports, "PhysicsSettings", { enumerable: true, get: function () { return settings_2.PhysicsSettings; } });
var simulators_1 = require("./simulators");
Object.defineProperty(exports, "BaseSimulator", { enumerable: true, get: function () { return simulators_1.BaseSimulator; } });
var engines_1 = require("./physics/engines");
Object.defineProperty(exports, "EntityPhysics", { enumerable: true, get: function () { return engines_1.EntityPhysics; } });
var states_1 = require("./physics/states");
Object.defineProperty(exports, "EntityState", { enumerable: true, get: function () { return states_1.EntityState; } });
var player_1 = require("./physics/player");
Object.defineProperty(exports, "ControlStateHandler", { enumerable: true, get: function () { return player_1.ControlStateHandler; } });
